import { memo, useState, useCallback } from 'react';
import ContainerBody from './ContainerBody';
import ContainerHeader from './ContainerHeader';
import { Container, Row, Col } from 'react-bootstrap';
import { BzTab, BzTabs, BzToolTip } from '../../../components';
import { APP_INFO_PARAMS, LAYOUT_TYPE, SIDE_TRAY_EXPAND_PERCENTAGE } from '../../../utils/global_variables';
import { MainCalculator } from '../../../containers';
import { useSelector } from 'react-redux';
import { getAppInfoData, getTabsForCalculator } from '../../../utils/global_functions';


const SideCalculators = ({ setIsExpanded, sideContentId,
    setActiveMenu, //BT- 112339 : Watchlist || Side Tray || Closing functionality : ManasaB : 30/06/2023
    setToggleSideContainer,
    ...props }) => {
    const [activeTab, setActiveTab] = useState('option_value');
    // const [toggleOptionBtn, setToggleOptionBtn] = useState(1);
    // Ajitesh - Get detail of APP_LINUX_MANAGER key from mobile admin app info
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const isSpanMarginCalcVisible = getAppInfoData(APP_INFO_PARAMS.APP_LINUX_MANAGER, appInfo);

    const objDropdownOptions = {
        expiryOrContractDays: ["26 APR'22  14Days", "30 MAY'22  34Days", "15 JUN'22  49Days", "31 JULY'22 125Days", "Custom Days   - 0 Days +"],
        strikePrice: ['530', '540', '550', '562'],
        optionValueCalculationMethod: ['Black and schols Pricing Model', 'Cox-Ross-Rubinstein Binomial Method'],
        pivotPointCalculationMethod: ['Classic', 'Woodie', 'Camarilla', 'Fibonacci'],
        pivotPointFormula: ['(H+L+C)/3', '(H+L+O)/3', '(H+L+C+O)/4', '(H+L+C+C)/4', '(H+L+O+O)/4', '(H+L)/2']
    };

    const [selectCalculatorOption, setSelectCalculatorOption] = useState({
        expiryOrContractDays: "26 APR'22  14Days",
        strikePrice: '530',
        optionValueCalculationMethods: 'Black and schols Pricing Model',
        pivotPointCalculationMethod: 'Classic',
        pivotPointFormula: '(H+L+C)/3'
    });

    const handleOnSelectCalculatorOptionChange = useCallback((e) => {
        const { name, value } = e.target;
        setSelectCalculatorOption(prev => ({ ...prev, [name]: value }));
    }, []);

    const [calculatorInputs, setCalculatorInputs] = useState({ spotPrice: 0, interestRate: 0, volatility: 0, dividend: 0, openPrice: 0, highPrice: 0, lowPrice: 0, closePrice: 0 });

    const handleCalculatorInputs = useCallback((e) => {
        const { name, value } = e.target;
        setCalculatorInputs(curr => ({ ...curr, [name]: value }));
    }, []);

    // Calls global function to get tabs for calculator based on key value in mobile admin
    const arrCalcuatorTabs = getTabsForCalculator(isSpanMarginCalcVisible);

    return (
        <>
            <ContainerHeader sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer}>
                <Container fluid className='p-0'>
                    <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size5 color-text text-uppercase line-height-1'>CALCULATORS</div>
                            {props.children}
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                <div className='icon-16 icon-dark icon-close ms-3' onClick={() => {
                                    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
                                    setToggleSideContainer(false);
                                    setActiveMenu({});
                                }}>
                                </div>
                            </BzToolTip>
                        </Col>
                    </Row>

                    <Row className='g-0 mt-2 px-3'>
                        <Col>
                            <div className='horizontal-scroll-wrap'>
                                <BzTabs className='nav nav-tabs'>
                                    {arrCalcuatorTabs?.map((each) => (
                                        <BzTab key={each?.id} className='nav-link text-capitalize' isActive={each.tab_key === activeTab} tabKey={each.tab_key} onClick={() => setActiveTab(each.tab_key)}>{each.name}</BzTab>
                                    ))}
                                </BzTabs>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </ContainerHeader>

            <ContainerBody>
                <MainCalculator activeTab={activeTab} layoutType={LAYOUT_TYPE.VERTICAL} objDropdownOptions={objDropdownOptions} selectCalculatorOption={selectCalculatorOption} setSelectCalculatorOption={setSelectCalculatorOption} handleOnSelectCalculatorOptionChange={handleOnSelectCalculatorOptionChange} calculatorInputs={calculatorInputs} setCalculatorInputs={setCalculatorInputs} handleCalculatorInputs={handleCalculatorInputs} />
            </ContainerBody>
        </>
    );
};

export default memo(SideCalculators);